export default __webpack_public_path__ + "static/esatto-fe80acdf4638d31a761009e51b766cff.gif";